import * as R from 'ramda';
import React from 'react';
import {withRouter} from 'react-router-dom';

import {translate} from 'iss/strings';
import {createQuestionGroup, deleteQuestionGroup, modifyQuestionGroup, subscribeToQuestionGroup} from 'iss/service/QuestionService';
import styles from 'iss/styles/QuestionGroupEditor.styl';
import {Button, CancelButton, SubmitButton} from 'iss/widgets/Buttons';
import {FormWithState, Input} from 'iss/widgets/Forms';
import {RestResultMessage} from 'iss/widgets/MessageBox';
import Modal from 'iss/widgets/bootstrap/Modal';
import validators from 'iss/widgets/form/validation/validators';

const QuestionGroupEditor = withRouter(subscribeToQuestionGroup(class extends React.Component {
  state = {
    backendError: null,
  };
  saveQuestionGroup = ({id, description}) => {
    const data = {
      description,
    };

    if(this.isNew()) {
      createQuestionGroup(data).subscribe(() => this.props.history.push("/question-groups?success=true"),
                          (errorResponse) => this.setState({backendError: errorResponse}));
    } else {
      modifyQuestionGroup(id, data).subscribe(() => this.props.history.push("/question-groups?success=true"),
                          (errorResponse) => this.setState({backendError: errorResponse}));
    }

  };
  isNew = () => {
    return !this.props.group.id;
  };

  deleteGroup = () => {
    deleteQuestionGroup(this.props.group.id).subscribe(() => this.props.history.push("/question-groups?deleteSuccess=true"),
      (errorResponse) => this.setState({backendError: errorResponse}));
  };

  render() {
    return <FormWithState initialValues={this.props.group} className="tight-form-controls" onSubmit={this.saveQuestionGroup}>
      <h1>{translate(this.isNew() ? 'questionGroupEditor.newGroupTitle' : 'questionGroupEditor.editGroupTitle')}</h1>

      <Input label="domain.questionGroup.groupDescription" id="group-description" valuePath="description" validate={validators.required} maxLength="255" showCounter={true}/>
      <RestResultMessage id="backendError" result={this.state.backendError} />
      <div className="form-group">
        <SubmitButton id="save-group" text={translate('common.save')} />
        <CancelButton link="/question-groups" />
        {!this.isNew() ? <DeleteGroupButton onChanged={this.deleteGroup} /> : null}
      </div>
    </FormWithState>;
  }
}));

class DeleteGroupButton extends React.Component {
  state = {
    showModal: false,
    backendError: null,
  };
  toggleModal = () => {
    this.setState(R.evolve({showModal: R.not}));
  };
  deleteGroup = () => {
    const {onChanged} = this.props;
    this.toggleModal();
    onChanged();
  };
  render() {
    return <React.Fragment>
      <Button buttonLook="danger" onClick={this.toggleModal} id="delete-group" className={styles.floatButton}>
        {translate('questionGroupEditor.deleteGroup')}
      </Button>
      <Modal title={translate('questionGroupEditor.deleteGroup')} visible={this.state.showModal} size="medium" onClose={this.toggleModal}>
        {{
          body: <p>{translate('questionGroupEditor.doYouWantToDelete')}</p>,
          footer: <React.Fragment>
            <CancelButton onClick={this.toggleModal} id="cancel-delete" />
            <Button buttonLook="danger" onClick={this.deleteGroup} id="confirm-delete">
              {translate('questionGroupEditor.delete')}
            </Button>
            <RestResultMessage id="deleteGroupError" result={this.state.backendError} />
          </React.Fragment>
        }}
      </Modal>
    </React.Fragment>;
  }
}

export default QuestionGroupEditor;



// WEBPACK FOOTER //
// ./modules/issFrontend/pages/QuestionGroupEditor.jsx